import moment from "moment";
import {
  Box, Flex, FormControl, FormLabel, Switch,
} from "@chakra-ui/react";
import AttributeButton from "components/Button/AttributeButton";
import MonthCalendar from "components/Calendar/MonthCalendar";
import { CalendarEvent } from "components/Calendar/types";

interface ScheduleMonthViewProps {
  events: CalendarEvent[];
  selectedDate: moment.Moment;
  timezone: string;
  showWeekends: boolean;
  onDateChange: (newDate: moment.Moment) => void;
  onShowWeekendsChange: (value: boolean) => void;
  onEventClick: (event: CalendarEvent) => void;
}

export default function ScheduleMonthView({
  events,
  selectedDate,
  timezone,
  showWeekends,
  onDateChange,
  onShowWeekendsChange,
  onEventClick,
}: ScheduleMonthViewProps) {
  // Use the selected date's month
  const visibleMonth = selectedDate.clone();
  const dateLabel = visibleMonth.format("MMMM YYYY");

  // Navigation handlers
  const handlePrevious = () => {
    onDateChange(selectedDate.clone().subtract(1, "month"));
  };

  const handleNext = () => {
    onDateChange(selectedDate.clone().add(1, "month"));
  };

  return (
    <Flex direction="column" width="100%">
      {/* Calendar controls */}
      <Flex justify="space-between" align="center" px="4" py="2">
        <FormControl display="flex" alignItems="center" width="auto">
          <FormLabel htmlFor="weekends-toggle-month" mb="0">Show weekends</FormLabel>
          <Switch
            id="weekends-toggle-month"
            isChecked={showWeekends}
            onChange={(e) => onShowWeekendsChange(e.target.checked)}
          />
        </FormControl>
        <Box fontWeight="bold" fontSize="lg">{dateLabel}</Box>
        <Flex>
          <AttributeButton onClick={handlePrevious}>← Prev</AttributeButton>
          <AttributeButton onClick={handleNext}>Next →</AttributeButton>
        </Flex>
      </Flex>

      {/* Month calendar */}
      <MonthCalendar
        visibleMonth={visibleMonth}
        events={events}
        timezone={timezone}
        handleClick={onEventClick}
        showWeekends={showWeekends}
      />
    </Flex>
  );
}
